import { createApi } from '@reduxjs/toolkit/query/react'
import { SubscribedApplicationRoles } from './models'
import { getBaseQuery } from './baseQuery'

// CONTRUCT ENDPOINTS AND API CALL HOOKS
export const applicationAPI = createApi({
  reducerPath: 'applicationAPI',
  baseQuery: getBaseQuery('Application'),
  tagTypes: ['app'],
  endpoints: builder => ({
    GetSubscribedApplicationRoles: builder.query<SubscribedApplicationRoles, void>({
      query: () => 'GetSubscribedApplicationRoles',
      providesTags: ['app'],
    }),
  }),
})

// Export the auto-generated hooks from the endpoints constructed in createApi
export const { useGetSubscribedApplicationRolesQuery } = applicationAPI
